module.exports = __webpack_public_path__ + "img/bucu_4kl.a4467866.jpg";